import RestaurantImage from './RestaurantImage';

export default RestaurantImage;